module.exports = __webpack_public_path__ + "img/pic_upgrade@2x.a20c0803.png";